import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, PAGE_SIZE } from '../common';
import { ILaboratory, ILabsFilter } from './models';

export const laboratoriesApiSlice = createApi({
  reducerPath: 'laboratories/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'laboratories/',
  }),
  endpoints: builder => ({
    getLabs: builder.query<IState<ILaboratory>, ILabsFilter>({
      query: data => ({
        url: `fn/search`,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: IAxiosResponse<ILaboratory[]>): IState<ILaboratory> => {
        return {
          data: [...response.data],
          isEnd: !!response.data?.length && response.data?.length < PAGE_SIZE,
        };
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.skip && otherArgs.arg.skip > 0) {
          responseData.data.unshift(...currentCacheData.data);
          return responseData;
        }
        return responseData;
      },
    }),
  }),
});
